// Generated by `npm run scene:import`. Do not edit by hand.
/** Newest authored scene revision per track id (presentation only). */
export const TRACK_SCENE_MANIFESTS: Readonly<Record<number, string>> = {
  1: '/assets/scenes/track-1/v7/visual.json',
  2: '/assets/scenes/track-2/v8/visual.json',
  3: '/assets/scenes/track-3/v6/visual.json',
  4: '/assets/scenes/track-4/v6/visual.json',
};
